import React, { useEffect, useState } from "react";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { Spinner } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";
import {
  AUTHENTICATION_REQUIRED_EVENT,
  refreshStoredAccessToken,
  setAccessTokenProvider,
} from "../../util/authenticatedFetch";

const TOKEN_REFRESH_INTERVAL_MS = 5 * 60 * 1000;

export const AuthenticatedTokenGate = ({ component: Component }) => {
  const { getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();
  const [tokenReady, setTokenReady] = useState(false);

  useEffect(() => {
    let active = true;
    setAccessTokenProvider(getAccessTokenSilently);

    const failAuthentication = () => {
      if (!active) return;
      setTokenReady(false);
      navigate("/logout", { replace: true });
    };

    const refreshToken = async (force = false) => {
      try {
        await refreshStoredAccessToken({ force });
        if (active) setTokenReady(true);
      } catch (_error) {
        failAuthentication();
      }
    };

    const handleAuthenticationRequired = () => failAuthentication();
    window.addEventListener(
      AUTHENTICATION_REQUIRED_EVENT,
      handleAuthenticationRequired
    );
    refreshToken();
    const refreshTimer = window.setInterval(
      () => refreshToken(),
      TOKEN_REFRESH_INTERVAL_MS
    );

    return () => {
      active = false;
      window.clearInterval(refreshTimer);
      window.removeEventListener(
        AUTHENTICATION_REQUIRED_EVENT,
        handleAuthenticationRequired
      );
      setAccessTokenProvider(null);
    };
  }, [getAccessTokenSilently, navigate]);

  if (!tokenReady) {
    return (
      <div
        className="d-flex justify-content-center aligns-Items-center h-100vh w-100"
        aria-label="Preparing secure PalSync access"
      >
        <Spinner accessibilityLabel="Preparing secure PalSync access" size="large" />
      </div>
    );
  }

  return <Component />;
};

const AuthenticatedRoute = withAuthenticationRequired(AuthenticatedTokenGate);

const ProtectedRoute = (props) => <AuthenticatedRoute {...props} />;

export default ProtectedRoute;
